module.exports = __webpack_public_path__ + "img/content (6).8617ef29.jpg";